import { ButtonTheme, IBorderRadiusData, ICheckoutPagesSettingsData, IFontData, IInteractiveElementColorData, IPagePrimaryElement, WidgetPlaceType } from "./index";
import { IAnimatedWidget } from "./widget-style-data";

export interface ICheckoutWidgetData extends IPagePrimaryElement {
    id?: string | null;
    readonly type: "CheckoutWidget";
    placeType: WidgetPlaceType;
    testMode: boolean;
    checkoutPages: ICheckoutPagesSettingsData;
    style?: IStoreCheckoutWidgetStyle;
}

export interface ICheckoutWidgetShortData {
    testMode: boolean;
    buttonTheme?: ButtonTheme | null;
}

export interface IStoreCheckoutWidgetStyle extends IAnimatedWidget {
    container: IMainContainerStyle;
    summaryContainer: ISummaryContainerStyle;
    button: IButtonStyle;
}

export interface IButtonStyle {
    theme?: ButtonTheme | null;
    color?: IInteractiveElementColorData | null;
    backgroundColor?: IInteractiveElementColorData | null;
    borderColor?: IInteractiveElementColorData | null;
    borderRadius?: IBorderRadiusData | null;
    font?: IFontData | null;
    thickness?: string | null;
}

export interface IMainContainerStyle extends IContainerStyle {
    inputBorderColor: string;
    linkColor: IInteractiveElementColorData;
    errorMessageColor: string | null;
}

export interface ISummaryContainerStyle extends IContainerStyle {
    dividerColor?: string | null;
}

export interface IContainerStyle {
    backgroundColor: string;
    borderRadius?: IBorderRadiusData | null;
    font: IFontData;
    secondaryFont: IFontData;
}

export abstract class StoreCheckoutWidgetData {

    public static get defaultStyle(): IStoreCheckoutWidgetStyle {
        return {
            container: {
                inputBorderColor: "rgb(220, 224, 229)",
                linkColor: {
                    colorDefault: "rgb(14, 123, 196)",
                    colorHovered: "rgb(18, 163, 248)",
                },
                font: {
                    family: "Open Sans",
                    color: "rgb(57, 60, 64)"
                },
                secondaryFont: {
                    color: "rgba(57, 60, 64, 0.6)"
                },
                backgroundColor: "rgb(255, 255, 255)",
                borderRadius: {
                    topLeftPx: 12,
                    topRightPx: 12,
                    bottomLeftPx: 12,
                    bottomRightPx: 12
                },
                errorMessageColor: "rgb(249, 60, 0)"
            },
            summaryContainer: {
                font: {
                    family: "Open Sans",
                    color: "rgb(57, 60, 64)"
                },
                secondaryFont: {
                    color: "rgba(57, 60, 64, 0.6)"
                },
                backgroundColor: "rgb(240, 242, 245)",
                borderRadius: {
                    topLeftPx: 12,
                    topRightPx: 12,
                    bottomLeftPx: 12,
                    bottomRightPx: 12
                },
                dividerColor: "rgb(220, 224, 229)"
            },
            button: {
                theme: "primary",
                borderRadius: {
                    topLeftPx: 8,
                    topRightPx: 8,
                    bottomLeftPx: 8,
                    bottomRightPx: 8
                },
                thickness: "0px",
                font: {
                    weight: "400",
                    size: "1rem",
                    color: "rgb(0, 0, 0)",
                }
            },
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            }
        };
    }

    public static localScriptRerenderNeeded(leftHandSide?: ICheckoutWidgetData | null, rightHandSide?: ICheckoutWidgetData | null): boolean {
        return leftHandSide?.id === rightHandSide?.id &&
            leftHandSide?.testMode === rightHandSide?.testMode &&
            leftHandSide?.style?.button.theme === rightHandSide?.style?.button.theme;
    }

}
